export default __webpack_public_path__ + "static/media/count_up.3da4ab80.svg";